import React from 'react';

import { IButton } from './Button';
import { ButtonStyle, Spinner } from './ButtonElements';

const Button = (props: IButton.IProps) => {
  return (
    <ButtonStyle {...props}>
      {props.isLoading ? (
        <Spinner />
      ) : (
        <>
          {props.label}
          {props.children}
        </>
      )}
    </ButtonStyle>
  );
};

Button.defaultProps = {
  disabled: false,
  color: 'green',
  size: 'medium',
  isLoading: false,
  isLinear: false,
  fullWidth: false,
  label: '',
  reverse: false,
  onClick: () => null,
};

export { Button };
